import Toastify from 'toastify-js';

document.addEventListener('click', (e) => {
    if (!e.target.closest('.js-ask-product-dialog-open')) return;

    document.querySelector('.js-ask-product-dialog').showModal();
});

document.addEventListener('click', (e) => {
    if (!e.target.closest('.js-ask-product')) return;

    const hasErrors = handleRequiredInput();
    if (hasErrors === true) return;

    let formData = new FormData();
    formData.append('action', 'submit_ask_product');
    formData.append('name', document.getElementById('ask-product-name').value);
    formData.append('company', document.getElementById('ask-product-company').value);
    formData.append('email', document.getElementById('ask-product-email').value);
    formData.append('phone', document.getElementById('ask-product-phone').value);
    formData.append('comment', document.getElementById('ask-product-comment').value);
    formData.append('product_name', document.querySelector('.product_title').innerText);
    formData.append('product_sku', document.querySelector('.product_sku').innerText);


    console.log(formData);
    fetch(adminUrl, {
        method: 'post',
        body: formData,
    })
        .then((response) => {
            return response.text();
        })
        .then((response) => {
            document.querySelector('.form-ask-product textarea').value = '';
            document.querySelector('.js-ask-product').classList.remove('button--primary');
            document.querySelector('.js-ask-product').classList.add('button--success');
            
            setTimeout(() => {
                document.querySelector('.js-ask-product').classList.remove('button--success');
                document.querySelector('.js-ask-product').classList.add('button--primary');
                document.querySelector('.js-ask-product-dialog').close();

                Toastify({
                    text: 'Vraag/opmerking is succesvol verzonden.',
                    duration: 2000,
                    className: 'success',
                    avatar: themeUrl + '/assets/images/check.svg',
                    gravity: 'bottom',
                    position: 'right'
                }).showToast();
            }, 1000);
        })
        .catch((response) => {
            console.log(response);
        });
});

function handleRequiredInput() {
    let errors = false;

    document
        .querySelectorAll('.form-ask-product input[required]')
        .forEach((el) => {
            if (el.value.length < 1) {
                el.classList.add('has-error');

                Toastify({
                    text: el.closest('.input-field').querySelector('label').innerText + ' is een verplicht veld',
                    duration: 2000,
                    className: 'error',
                    avatar: themeUrl + '/assets/images/cancel.svg',
                    gravity: 'bottom',
                    position: 'right'
                }).showToast();

                errors = true;
            } else {
                el.classList.remove('has-error');
            }
        });

    document
        .querySelectorAll('.form-ask-product textarea[required]')
        .forEach((el) => {
            if (el.value.length < 1) {
                el.classList.add('has-error');

                Toastify({
                    text: el.closest('.input-field').querySelector('label').innerText + ' is een verplicht veld',
                    duration: 2000,
                    className: 'error',
                    avatar: themeUrl + '/assets/images/cancel.svg',
                    gravity: 'bottom',
                    position: 'right'
                }).showToast();

                errors = true;
            } else {
                el.classList.remove('has-error');
            }
        });

    return errors;
}